<script setup lang="ts">
import { VIcons } from '@/shared/ui'
import { useReportSubscriptionModel } from '@/widgets'

const model = useReportSubscriptionModel()
</script>

<template>
  <VTooltip :text="$t('itf.send_report_to_time')" location="top" activator="#subscription-button" />

  <VBtn
    id="subscription-button"
    v-bind="$attrs"
    color="warning"
    @click.prevent="model.openForm = true"
  >
    <VIcons type="calendar_month" />
  </VBtn>
</template>
